export enum StatusIndicator {
  Success = 'success',
  Error = 'error',
  FinalSuccess = 'final-success',
  FinalError = 'final-error',
  CompletedSuccess = 'completed-success'
}
